import { Box } from "@mui/material";

import Image from "@/components/Image/Image";

export const ThemedFormPeerToPeerCampaignLogo = ({ src }: { src: string }) => {
  return (
    <Box
      sx={{
        height: { xs: 30, md: 42 },
        width: { xs: 30, md: 42 },
        borderRadius: 1,
        flexShrink: 0,
        overflow: "hidden",
      }}
    >
      <Image
        src={src}
        alt="Logo"
        data-test="form-header-logo"
        width="100%"
        height="100%"
        resolution={100}
        style={{
          objectFit: "contain",
        }}
      />
    </Box>
  );
};
